// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2CWKg","title":"BackImages_title__2pYd4","images":"BackImages_images__Do_BP"};